import { computed, shallowRef } from 'vue'

const denied = Object.freeze({ edit: false, export: false, admin: false })
const legacy = Object.freeze({ edit: true, export: true, admin: true })
export function normalizeResearchPermissions(user) {
  const policy = user?.research_permissions
  if (policy == null) return legacy
  if (typeof policy !== 'object' || Array.isArray(policy) ||
      Object.keys(policy).sort().join(',') !== 'admin,edit,export' ||
      !['edit', 'export', 'admin'].every(key => typeof policy[key] === 'boolean')) return denied
  return policy
}
export function authToken() {
  try { return localStorage.getItem('authToken_org') || localStorage.getItem('authToken1_org') || '' } catch { return '' }
}
export const researchIdentity = shallowRef({ user: null, token: '', pending: false })
export function setResearchIdentity(user, token = authToken(), pending = false) {
  researchIdentity.value = { user, token, pending }
}
export function readResearchPermissions() {
  const state = researchIdentity.value
  // Token replacement must never reuse the previous account's permissions.
  if (state.pending || state.token !== authToken() || (!state.user && authToken())) return denied
  return normalizeResearchPermissions(state.user)
}
export const canResearchEdit = computed(() => readResearchPermissions().edit)
export const canResearchExport = computed(() => readResearchPermissions().export)
export const canResearchAdmin = computed(() => readResearchPermissions().admin)
// Monitoring Operations are subject-level work, not organization/account administration.
export const canResearchMonitoringEdit = computed(() => readResearchPermissions().edit)
export const isResearchRestricted = computed(() => !canResearchExport.value || !canResearchAdmin.value)
export function assertResearchPermission(action) {
  if (!readResearchPermissions()[action]) throw new Error('当前账号无此操作权限')
}
export const restrictedResearchPaths = new Set([
  '/cohorts', '/cohort', '/cohort/subjects', '/cohort/reports', '/cohort/reports/night',
  '/cohort/realtime', '/cohort/field-dictionary', '/field-dictionary', '/access-denied', '/login',
])
export function researchRouteAllowed(user, path) {
  const policy = normalizeResearchPermissions(user)
  if (!policy.edit) return path === '/access-denied' || path === '/login'
  const normalizedPath = path.replace(/\/$/, '') || '/'
  if (normalizedPath === '/cohort/reports/print') return policy.export
  return policy.admin && policy.export || restrictedResearchPaths.has(normalizedPath)
}
export function richReportRequest(user, params = {}) {
  const policy = normalizeResearchPermissions(user)
  if (!policy.edit) throw new Error('当前账号无查看权限')
  if (policy.admin && policy.export) return { path: '/cohort/rich-reports', params }
  return { path: '/cohort/rich-reports/view', params: {
    ...params, page: Math.max(1, Math.floor(Number(params.page) || 1)),
    page_size: Math.max(1, Math.min(100, Math.floor(Number(params.page_size) || 100))),
  } }
}

// /cohort/orgs nodes use the canonical orgbind as id; display names are not identity.
// Capability comes only from the fresh authenticated server identity, not local roles or selection.
export const canManageResearchSubaccounts = computed(() => {
  const state = researchIdentity.value
  return !!state.token && state.token === authToken() && !state.pending &&
    state.user?.can_manage_research_subaccounts === true &&
    state.user?.research_permissions == null
})

// Scope to the explicit card org even when no cohort (or another cohort) is selected.
export function canShowResearchSubaccounts(org) {
  return org === '河南省人民医院' && canManageResearchSubaccounts.value
}
